import React, { memo } from 'react';
import { cn } from '../lib/utils';
interface HeroProps {
  className?: string;
}
export function Hero({
  className
}: HeroProps) {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className={cn('relative min-h-screen w-full flex flex-col items-center justify-center px-6 py-24', className)} data-id="element-41">
      <div className="z-10 flex flex-col items-center text-center max-w-4xl w-full mt-12" data-id="element-42">
        <h1 className="text-6xl md:text-8xl lg:text-9xl font-light tracking-wider mb-6 slow-pulse text-foreground" data-id="element-43">
          Noise Lullabies
        </h1>

        <div className="mb-12" data-id="element-44">
          <span className="font-mono text-sm md:text-base tracking-[0.3em] uppercase" data-id="element-45">
            <span className="text-coral coral-glow" data-id="element-46">sic</span>{' '}
            <span className="text-muted-foreground mx-2" data-id="element-47">/</span>{' '}
            <span className="text-muted-foreground" data-id="element-48">Akshay Gite</span>
          </span>
        </div>

        <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-20 font-light" data-id="element-49">
          An artistic research and spatial sound project exploring lullabies as
          cultural memory, affective transmission, and immersive listening
          environments.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 font-mono text-xs md:text-sm tracking-widest uppercase text-muted-foreground" data-id="element-50">
          <button onClick={() => scrollTo('contact')} className="hover:text-coral transition-colors duration-500" data-id="element-51">
            Listen to demos
          </button>
          <span className="hidden sm:inline text-border" data-id="element-52">/</span>
          <button onClick={() => scrollTo('concept')} className="hover:text-coral transition-colors duration-500" data-id="element-53">
            View project concept
          </button>
          <span className="hidden sm:inline text-border" data-id="element-54">/</span>
          <button onClick={() => scrollTo('spatial')} className="hover:text-coral transition-colors duration-500" data-id="element-55">
            Residency proposal
          </button>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center opacity-30 breathe" data-id="element-56">
        <div className="w-[1px] h-12 bg-gradient-to-b from-coral to-transparent" data-id="element-57"></div>
      </div>
    </section>;
}